module.exports = __webpack_public_path__ + "img/end.e0a27d0d.png";